export default __webpack_public_path__ + "static/media/GifSite1.4c8c2880.mp4";